import { render, staticRenderFns } from "./HotSpotStatement.vue?vue&type=template&id=cbfa8aa0"
import script from "./HotSpotStatement.vue?vue&type=script&lang=js"
export * from "./HotSpotStatement.vue?vue&type=script&lang=js"
import style0 from "./HotSpotStatement.vue?vue&type=style&index=0&id=cbfa8aa0&prod&lang=scss"
import style1 from "./HotSpotStatement.vue?vue&type=style&index=1&id=cbfa8aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports